import React, { useState } from "react";
import "./RegBank.css";

const POPULAR_BANKS = [
  { code: "SBIN", name: "State Bank of India" },
  { code: "HDFC", name: "HDFC Bank" },
  { code: "ICIC", name: "ICICI Bank" },
  { code: "UTIB", name: "Axis Bank" },
  { code: "PUNB", name: "Punjab National Bank" },
  { code: "BARB", name: "Bank of Baroda" },
  { code: "CNRB", name: "Canara Bank" },
  { code: "HPSC", name: "Himachal Pradesh State Co-operative Bank" },
];

const RegBank = () => {
  // Form state
  const [accHolderName, setAccHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [fileName, setFileName] = useState("No file chosen");
  const [fileSelected, setFileSelected] = useState(false);

  // Interaction state
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showChequeModal, setShowChequeModal] = useState(false);
  const [activeChequeRow, setActiveChequeRow] = useState(null);

  // Table Data State
  const [bankList, setBankList] = useState([
    {
      idno: "10129",
      name: "NTS ONLINE SERVICES PVT LTD",
      accountNo: "43820105878",
      ifsc: "HPSC0000438",
      bank: "HPSC0000051",
      branch: "SHIMLA",
      status: "Verified",
    },
  ]);

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setFileSelected(true);
    } else {
      setFileName("No file chosen");
      setFileSelected(false);
    }
  };

  // Simulating Account Verification
  const handleVerify = () => {
    if (!accountNumber || !ifscCode) {
      alert("Please fill in Account Number and IFSC code first to verify.");
      return;
    }
    setIsVerifying(true);

    setTimeout(() => {
      setIsVerifying(false);
      setIsVerified(true);
      // Auto-fill account holder name if empty
      if (!accHolderName) {
        setAccHolderName("NTS ONLINE SERVICES PVT LTD");
      }
      alert("Account verification successful!");
    }, 1500);
  };

  // Simulating Save Record
  const handleSave = (e) => {
    e.preventDefault();
    if (!accHolderName || !accountNumber || !selectedBank || !ifscCode || !branchName) {
      alert("Please fill in all the bank details before saving.");
      return;
    }
    if (!fileSelected) {
      alert("Please upload a Cancelled Cheque image.");
      return;
    }

    setIsSaving(true);

    setTimeout(() => {
      const newIdno = String(Math.floor(10000 + Math.random() * 90000));
      const newRecord = {
        idno: newIdno,
        name: accHolderName.toUpperCase(),
        accountNo: accountNumber,
        ifsc: ifscCode.toUpperCase(),
        bank: selectedBank,
        branch: branchName.toUpperCase(),
        status: isVerified ? "Verified" : "Pending",
      };

      setBankList([newRecord, ...bankList]);
      setIsSaving(false);
      
      // Reset form
      setAccHolderName("");
      setAccountNumber("");
      setSelectedBank("");
      setIfscCode("");
      setBranchName("");
      setFileName("No file chosen");
      setFileSelected(false);
      setIsVerified(false);
    }, 1000);
  };

  // Handle Delete Record
  const handleDelete = (idno) => {
    if (window.confirm(`Are you sure you want to delete bank registration #${idno}?`)) {
      setBankList(bankList.filter((item) => item.idno !== idno));
    }
  };

  // Triggered when user clicks "View Check"
  const openChequeViewer = (item) => {
    setActiveChequeRow(item);
    setShowChequeModal(true);
  };

  return (
    <div className="opay-bank-container mt-3">
      {/* Top Header Filter Bar */}
      <div className="opay-bank-header-bar mb-4">
        <div className="opay-bank-left">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="opay-bank-home-icon me-1" style={{ verticalAlign: "middle" }}>
            <path d="M3 21h18M3 10h18M5 10V21M19 10V21M9 10V21M15 10V21M12 2L3 10h18L12 2z" />
          </svg>
          <span className="opay-bank-breadcrumb-label ms-2">Website Bank Registration Info</span>
        </div>
      </div>

      {/* Main Container Info Cards (Matching PlanInfo Cards Style) */}
      <div className="opay-bank-info-cards mb-4">
        <div className="opay-bank-card-item card-bank-total">
          <div className="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="20" height="14" x="2" y="5" rx="2" />
              <line x1="2" x2="22" y1="10" y2="10" />
            </svg>
          </div>
          <div className="card-details">
            <span className="card-label">Total Registered</span>
            <span className="card-value gradient-text">{bankList.length} Account(s)</span>
          </div>
        </div>
        <div className="opay-bank-card-item card-bank-primary">
          <div className="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <div className="card-details">
            <span className="card-label">Primary Account</span>
            <span className="card-value">{bankList[0]?.name || "No Accounts"}</span>
          </div>
        </div>
        <div className="opay-bank-card-item card-bank-status">
          <div className="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <div className="card-details">
            <span className="card-label">Overall Status</span>
            <div className="card-status-wrapper">
              <span className="live-pulse-dot"></span>
              <span className="card-value text-success">Active & Online</span>
            </div>
          </div>
        </div>
      </div>

      {/* Warning/Guideline Banner (Matching PlanInfo Warning Banner Style) */}
      <div className="opay-bank-limit-banner mb-4">
        <div className="limit-left">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="me-2 text-danger" style={{ verticalAlign: "middle" }}>
            <circle cx="12" cy="12" r="10" />
            <line x1="12" x2="12" y1="8" y2="12" />
            <line x1="12" x2="12.01" y1="16" y2="16" />
          </svg>
          <span className="limit-warning-text">Verification Guideline:</span>
        </div>
        <div className="limit-right">
          <span className="limit-storage-text">Upload a clear copy of a cancelled cheque containing the printed name of the account holder. Mismatching files will result in verification failure.</span>
        </div>
      </div>

      {/* Main Form Input Panel (Matches screenshot inputs list, built with premium aesthetics) */}
      <div className="opay-bank-form-card mb-4">
        <h5 className="form-card-title mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">
            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
            <path d="M12 8v8"/>
            <path d="M8 12h8"/>
          </svg>
          Register New Bank Account
        </h5>
        
        <form onSubmit={handleSave} className="bank-registration-form">
          <div className="row g-3 align-items-end">
            {/* Account Holder Name */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="opay-input-group">
                <label className="opay-label-text">Acc Holder Name</label>
                <input
                  type="text"
                  className="opay-form-control"
                  placeholder="Enter Account Holder Name"
                  value={accHolderName}
                  onChange={(e) => setAccHolderName(e.target.value)}
                />
              </div>
            </div>

            {/* Account Number */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="opay-input-group">
                <label className="opay-label-text">Account Number</label>
                <input
                  type="text"
                  className="opay-form-control"
                  placeholder="Enter Account Number"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
            </div>

            {/* Select Bank Name Dropdown */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="opay-input-group">
                <label className="opay-label-text">Select Bank Name</label>
                <select
                  className="opay-form-select"
                  value={selectedBank}
                  onChange={(e) => setSelectedBank(e.target.value)}
                >
                  <option value="">Select Bank Name</option>
                  {POPULAR_BANKS.map((b) => (
                    <option key={b.code} value={b.name}>
                      {b.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* IFSC Code */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="opay-input-group">
                <label className="opay-label-text">IFSC</label>
                <input
                  type="text"
                  className="opay-form-control"
                  placeholder="Enter IFSC"
                  value={ifscCode}
                  onChange={(e) => setIfscCode(e.target.value)}
                />
              </div>
            </div>

            {/* Branch Name */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="opay-input-group">
                <label className="opay-label-text">Branch Name</label>
                <input
                  type="text"
                  className="opay-form-control"
                  placeholder="Enter Branch Name"
                  value={branchName}
                  onChange={(e) => setBranchName(e.target.value)}
                />
              </div>
            </div>

            {/* Cancel Check Upload */}
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="opay-input-group">
                <label className="opay-label-text">Cancel Check</label>
                <div className="custom-file-upload-wrapper">
                  <label className="file-upload-button-label">
                    Choose File
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden-file-input"
                      onChange={handleFileChange}
                    />
                  </label>
                  <span className={`file-upload-name ${fileSelected ? "file-active" : ""}`}>
                    {fileName}
                  </span>
                </div>
              </div>
            </div>

            {/* Buttons Panel */}
            <div className="col-lg-5 col-md-12 col-sm-12 d-flex gap-2 justify-content-lg-end mt-3">
              {/* Acc Verify Button */}
              <button
                type="button"
                className="opay-btn-verify"
                onClick={handleVerify}
                disabled={isVerifying}
              >
                {isVerifying ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Verifying...
                  </>
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="me-2 btn-icon">
                      <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                    Acc Verify
                  </>
                )}
              </button>

              {/* Save Button */}
              <button
                type="submit"
                className="opay-btn-save"
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="me-2 btn-icon">
                      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                      <polyline points="17 21 17 13 7 13 7 21"/>
                      <polyline points="7 3 7 8 15 8"/>
                    </svg>
                    Save
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* Main Table Card (Matches dashboard styles with dashed borders) */}
      <div className="opay-bank-table-card">
        <div className="table-responsive">
          <table className="table table-bordered opay-bank-table">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "40px" }}>
                  <input type="checkbox" className="custom-table-checkbox" />
                </th>
                <th>Idno</th>
                <th>Name</th>
                <th>Account Number</th>
                <th>Ifsc</th>
                <th>Bank</th>
                <th>Branch</th>
                <th>Status</th>
                <th>View</th>
                <th style={{ width: "60px" }}>#</th>
              </tr>
            </thead>
            <tbody>
              {bankList.map((item, idx) => (
                <tr key={item.idno}>
                  <td className="text-center">
                    <input type="checkbox" className="custom-table-checkbox" />
                  </td>
                  <td className="fw-semibold text-muted text-start">{item.idno}</td>
                  <td className="text-start fw-bold text-dark">{item.name}</td>
                  <td>{item.accountNo}</td>
                  <td>{item.ifsc}</td>
                  <td>{item.bank}</td>
                  <td>{item.branch}</td>
                  <td>
                    <span className={`opay-badge ${item.status === "Verified" ? "opay-badge-success" : "opay-badge-pending"}`}>
                      {item.status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="opay-btn-view"
                      onClick={() => openChequeViewer(item)}
                    >
                      View Check
                    </button>
                  </td>
                  <td>
                    <button
                      className="opay-btn-delete"
                      onClick={() => handleDelete(item.idno)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer Footnotes */}
      <div className="opay-bank-footer-notes mt-4">
        <ul className="list-unstyled text-danger">
          <li className="mb-1">• Verification charges of ₹1 + GST might apply per verification check</li>
          <li className="mb-1">• Check image size should be less than 2MB and in JPG/PNG format</li>
          <li className="mb-1">• Make sure that account holder name matches your profile details</li>
        </ul>
      </div>

      {/* Cancelled Cheque Viewer Modal */}
      {showChequeModal && activeChequeRow && (
        <div className="cheque-modal-overlay" onClick={() => setShowChequeModal(false)}>
          <div className="cheque-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="cheque-modal-header">
              <h5 className="modal-title">Cancelled Cheque Preview</h5>
              <button className="cheque-modal-close" onClick={() => setShowChequeModal(false)}>&times;</button>
            </div>
            <div className="cheque-modal-body text-center">
              <div className="cheque-container mb-3">
                <div className="cheque-header">
                  <div className="bank-logo-placeholder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="me-2">
                      <path d="M3 21h18M3 10h18M5 10V21M19 10V21M9 10V21M15 10V21M12 2L3 10h18L12 2z" />
                    </svg>
                    {activeChequeRow.bank}
                  </div>
                  <div className="ifsc-tag">IFSC: {activeChequeRow.ifsc}</div>
                </div>
                <div className="cheque-line payee-line">
                  <span className="cheque-label">PAY</span>
                  <span className="cheque-value text-start">YOURSELF OR ORDER</span>
                </div>
                <div className="cheque-line rupees-line">
                  <span className="cheque-label">RUPEES</span>
                  <span className="cheque-value text-start">Not Over Five Hundred Thousand Only</span>
                </div>
                <div className="cheque-bottom">
                  <div className="acc-info">
                    <div className="acc-number-label">A/C NO.</div>
                    <div className="acc-number-val">{activeChequeRow.accountNo}</div>
                  </div>
                  <div className="branch-info text-start">
                    <div>BRANCH: {activeChequeRow.branch}</div>
                    <div>STATUS: {activeChequeRow.status}</div>
                  </div>
                  <div className="sign-placeholder text-center">
                    <div className="holder-name">{activeChequeRow.name}</div>
                    <div className="sign-line">Authorised Signatory</div>
                  </div>
                </div>
                
                {/* Cancelled Stamp overlay */}
                <div className="cancelled-stamp">
                  CANCELLED
                </div>
              </div>
              <p className="text-muted fs-12 mb-0">Simulated Cheque preview based on registered details for ID: {activeChequeRow.idno}</p>
            </div>
            <div className="cheque-modal-footer">
              <button className="btn btn-secondary btn-sm" onClick={() => setShowChequeModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegBank;
